<template>
  <div class="waitingcallMessage waitingcallResult">
    <div v-if="result">
      <div class="title mb30" :data-result="result">
        <div v-if="spaceCodeName">
          <h2 class="notranslate">{{ spaceCodeName }}</h2>
          <p v-if="resultMessage && resultMessage.complete" class="preWrap">{{ resultMessage && resultMessage.complete }}</p>
          <p v-else class="notranslate">{{ locale.waitingcall_complete_apply }}</p>
        </div>
        <div v-else>
          <h2 v-if="resultMessage && resultMessage.complete" class="preWrap">{{ resultMessage && resultMessage.complete }}</h2>
          <div v-else class="notranslate">
            <h2>{{ locale.waitingcall_complete_apply }}</h2>
            <p>{{ locale.waitingcall_call_soon }}</p>
          </div>
        </div>
      </div>
      <div class="formBox notranslate">
        <button type="button" class="btn btnRound btnFull" @click.stop="goStatus">{{ locale.check_waiting }}</button>
      </div>
    </div>
    <div v-else>
      <div class="title mb30 notranslate">
        <h2>{{ locale.loading_waitingcall }}</h2>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'ln',
    'locale',
    'isPublic',
    'spaceCodeName',
    'info'
  ],
  computed: {
    spaceCode () {
      const authInfo = this.$store.getters['authentication/getAuthInfo']
      return authInfo && authInfo.spaceCode
    },
    rid () {
      return this.$route.params.rid
    },
    resultMessage () {
      const ln = this.ln
      const message = this.info && this.info.confirm
      const complete = message && message.waitingcall_result_complete
      const already = message && message.waitingcall_result_already
      return {
        complete: complete && complete[ln],
        already: complete && already[ln]
      }
    }
  },
  async created () {
    const spaceCode = this.spaceCode
    const rid = this.rid
    if (spaceCode && rid) {
      const data = {
        spaceCode: spaceCode,
        rid: rid
      }
      this.$store.commit('loading', true)
      this.$store.dispatch('waitingcall/getWaitingcallStatus', data).then((res) => {
        if (res && res.status && res.status === 200) {
          const sendResult = res.data && res.data.message
          if (sendResult && sendResult.currentStatus) {
            this.result = 'success'
            this.sendMethod = sendResult.type
          }
          this.$store.commit('loading', false)
        } else {
          const errorCode = res && res.message && res.message.code || 500
          const errorMessage = this.getResultData(errorCode)
          const reason = res && res.message && res.message.reason
          alert(this.locale[`alert_waitingcall_${errorMessage}`] + (reason ? `\n${reason}` : ''))
          this.$store.commit('loading', false)
        }
      })
    } else {
      alert(this.locale.access_correct_path)
    }
  },
  data () {
    return {
      result: null,
      sendMethod: null
    }
  },
  methods: {
    getResultMessage (sendMethod) {
      const message = this.locale.waitingcall_send_message
      const method = sendMethod === 'EMAIL' ? this.locale.email : this.locale.mobile
      return message.replace('{var}', method)
    },
    goStatus () {
      this.$router.push({
        name: 'waitingcallStatus'
      })
    }
  }
}
</script>

